module.exports = __webpack_public_path__ + "img/kefu_04.24676423.jpg";